"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoTableHeight = void 0;
const autoTableHeight = exports.autoTableHeight = {
  data() {
    return {
      height: "200px",
      heightVal: 200
    };
  },
  mounted() {
    this.getAutoHeight();
    const self = this;
    window.onresize = function () {
      self.getAutoHeight();
    };
  },
  methods: {
    getAutoHeight() {
      //window height
      let winclientHeight = window.innerHeight;
      // top bar height
      let topEle = document.querySelector(".main-container>:first-child");
      let topEleHeight = topEle.offsetHeight;
      // table filter height
      let searchlient = document.querySelector(".app-container>:first-child"),
        searchlientHeight = searchlient.offsetHeight;
      //console.info(searchlientHeight);
      //pagination container height
      let pageclient = document.querySelector(".pagination-container"),
        pageclientHeight = pageclient.offsetHeight ? pageclient.offsetHeight : 0;
      //console.info(pageclientHeight);
      setTimeout(() => {
        let heightVal = winclientHeight - (topEleHeight + searchlientHeight + pageclientHeight + 88);
        this.height = heightVal + "px";
        this.heightVal = heightVal;
      }, 500);
      setTimeout(() => {
        //let table_fixed = document.querySelector(".el-table__fixed");
        let table_fixed = document.querySelector(".el-table__fixed");
        //no scroll
        let no_scroll = document.querySelector(".is-scrolling-none");
        if (table_fixed !== null && no_scroll === null) {
          let table_fixedHeight = table_fixed.offsetHeight;
          //console.info("table_fixedHeight:" + table_fixedHeight);
          table_fixed.style.height = this.heightVal - 17 + "px";
          table_fixedHeight = table_fixed.offsetHeight;
          // console.info("table_fielx:" + table_fixedHeight);
          //console.info(this.heightVal)
        }
      }, 1000);
      // this.$nextTick(() => {

      // });
    }
  }
};